// @ts-nocheck
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";

import { createClient } from "contentful";

import Article from "../../templates/blog/article";
import ArticlesList from "../../templates/blog/articlesList";
import Author from "../../templates/blog/author";
import { getObjectFromSearchParams } from "../../helpers/urlUtils";

async function tidyEntry(client, entry) {
    if (entry.fields && entry.sys.id) {
        for (const [key, value] of Object.entries(entry.fields)) {
            if (typeof value === "object" && "fields" in value) {
                await tidyEntry(client, value);
            } else if (Array.isArray(value)) {
                if (typeof value[0] === "object" && "fields" in value[0]) {
                    for (let i = 0; i < value.length; i++) {
                        await tidyEntry(client, value[i]);
                    }
                } else if (typeof value[0] === "object" && "sys" in value[0] && value[0].sys.type === "Link") {
                    for (let i = 0; i < value.length; i++) {
                        const linkedEntry = await client.getEntry(value[i].sys.id);
                        await tidyEntry(client, linkedEntry);
                        value[i] = linkedEntry;
                    }
                }
            }

            entry[key] = value;
        }

        entry.id = entry.sys.id;

        if (entry.sys.contentType) {
            const contentType = entry.sys.contentType.sys.id;
            entry.__typename = `Contentful${contentType.charAt(0).toUpperCase()}${contentType.slice(1)}`;
        }

        delete entry.fields;
        delete entry.metadata;
        delete entry.sys;
    }
}

export default function Preview() {
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            const params = getObjectFromSearchParams();

            let space;
            let accessToken;

            if (
                params.entry_Article === "type" ||
                params.entry_type === "ArticlesList" ||
                params.entry_type === "Person"
            ) {
                space = "dbi9opon8gj1";
                accessToken = "ky_zKWmXrDHi91auhzqg8rBS4XdG4Wjx8Pcyrr0Iu8Q";
            }

            const client = createClient({
                space,
                accessToken,
                environment: params.env_id,
                host: "preview.contentful.com",
            });

            const entry = await client.getEntry(params.entry_id);
            await tidyEntry(client, entry);

            const finalEntry = {
                __typename: `Contentful${params.entry_type}`,
                [`contentful${params.entry_type}`]: entry,
            };

            setData(finalEntry);
        }

        fetchData();
    }, []);

    return (
        <div>
            {data && data.__typename === "ContentfulArticle" && <Article data={data} />}
            {data && data.__typename === "ContentfulArticlesList" && <ArticlesList data={data} />}
            {data && data.__typename === "ContentfulPerson" && <Author data={data} />}
        </div>
    );
}
